// How a player is playing (G2), as an icon where one fits: clubs name their own options, so the
// name picks the icon. No icon set has a golf cart; these are the nearest Lucide shapes. A name
// with no sensible match shows nothing (the word always shows beside it).

import { cn } from "@union/ui/lib/utils";
import { Backpack, Car, Footprints, type LucideIcon, ShoppingCart } from "lucide-react";
import type * as React from "react";

const MATCHES: [RegExp, LucideIcon][] = [
  [/push|pull|trolley/i, ShoppingCart], // before "cart": a push cart is a trolley, not a car
  [/cart|buggy/i, Car],
  [/caddie|caddy/i, Backpack],
  [/walk/i, Footprints],
];

/** The icon for a play option's name, or null when none fits. */
export function playOptionIcon(name: string): LucideIcon | null {
  return MATCHES.find(([pattern]) => pattern.test(name))?.[1] ?? null;
}

/** Decorative: always shown next to the option's name, never instead of it. */
function PlayOptionIcon({ name, className, ...props }: { name: string } & React.ComponentProps<"svg">) {
  const Icon = playOptionIcon(name);
  if (!Icon) return null;
  return (
    <Icon aria-hidden="true" strokeWidth={1.75} className={cn("size-4 shrink-0", className)} {...props} />
  );
}

export { PlayOptionIcon };
